<template>
	<el-row id="industry-intro">
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
			<div class="intro-container">
				<div class="box">
					<div class="item" @mouseenter="toggleImg(0)" @mouseleave="toggleImg(0)">
						<div class="left">
							<h4>{{data[0].title}}</h4>
							<p>{{data[0].content}}</p>
						</div>
						<div class="right">
							<img v-if="!item0On" :src="data[0].src[0]" />
							<img v-if="item0On" :src="data[0].src[1]" />
						</div>
					</div>
					<div class="item" @mouseenter="toggleImg(1)" @mouseleave="toggleImg(1)">
						<div class="left">
							<h4>{{data[1].title}}</h4>
							<p>{{data[1].content}}</p>
						</div>
						<div class="right">
							<img v-if="!item1On" :src="data[1].src[0]" />
							<img v-if="item1On" :src="data[1].src[1]" />
						</div>
					</div>
				</div>
				<div class="box">
					<div class="item" @mouseenter="toggleImg(2)" @mouseleave="toggleImg(2)">
						<div class="left">
							<h4>{{data[2].title}}</h4>
							<p>{{data[2].content}}</p>
						</div>
						<div class="right">
							<img v-if="!item2On" :src="data[2].src[0]" />
							<img v-if="item2On" :src="data[2].src[1]" />
						</div>
					</div>
					<div class="item" @mouseenter="toggleImg(3)" @mouseleave="toggleImg(3)">
						<div class="left">
							<h4>{{data[3].title}}</h4>
							<p>{{data[3].content}}</p>
						</div>
						<div class="right">
							<img v-if="!item3On" :src="data[3].src[0]" />
							<img v-if="item3On" :src="data[3].src[1]" />
						</div>
					</div>
				</div>
			</div>
		</el-col>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'IndustryIntro',
		props: ['data'],
		data() {
			return {
				item0On: false,
				item1On: false,
				item2On: false,
				item3On: false
			}
		},
		methods: {
			toggleImg(num) {
				switch (num) {
					case 0:
						this.item0On = !this.item0On;
						break;
					case 1:
						this.item1On = !this.item1On;
						break;
					case 2:
						this.item2On = !this.item2On;
						break;
					case 3:
						this.item3On = !this.item3On;
						break;
				}
			}
		}
	}
</script>

<style>
	@media (min-width:992px) {
		#industry-intro .intro-container {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
			height: 520px;
		}

		#industry-intro .intro-container .box {
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			height: 204px;
		}

		#industry-intro .intro-container .box:nth-child(1) {
			border-bottom: 1px solid #BCC4D0;
		}

		#industry-intro .intro-container .box .item {
			width: 50%;
			height: 204px;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
		}

		#industry-intro .intro-container .box .item:nth-of-type(odd) {
			border-right: 1px solid #BCC4D0;
		}

		#industry-intro .intro-container .box .item:nth-of-type(even) {
			margin-left: 0;
		}

		#industry-intro .intro-container .box .item .left {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
			/* width: 259px; */
			width: 50%;
		}

		#industry-intro .intro-container .box .item .right {
			width: 30%;
		}

		#industry-intro .intro-container .box .item img {
			width: 100%;
		}

		#industry-intro .intro-container .box .item .left h4 {
			color: #000000;
			font-family: "microsoft yahei";
			line-height: 1.1;
			font-size: 18px;
			float: left;
			font-weight: 500;
		}

		#industry-intro .intro-container .box .item .left p {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: rgba(132, 132, 132, 1);
			line-height: 24px;
			float: left;
			text-align: left;
			/* width: 96px; */
		}
	}


	@media (max-width:992px) {
		#industry-intro .intro-container {
			background-color: #eaf2f9;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
		}

		#industry-intro .intro-container .box {
			margin: 0 10px;
			width: 90%;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		#industry-intro .intro-container .box .item {
			width: 100%;
			height: 130px;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
		}

		#industry-intro .intro-container .box .item:not(:last-child),
		#industry-intro .intro-container .box:first-child {
			border-bottom: 1px solid #BCC4D0;
		}

		#industry-intro .intro-container .box .item .left {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
			width: 50%;
		}

		#industry-intro .intro-container .box .item .right {
			width: 80px;
			height: 80px;
		}

		#industry-intro .intro-container .box .item .left h4 {
			color: #000000;
			font-family: "microsoft yahei";
			line-height: 1.4;
			font-size: 16px;
			float: left;
		}

		#industry-intro .intro-container .box .item .left p {
			font-size: 12px;
			font-family: "microsoft yahei";
			color: rgba(132, 132, 132, 1);
			line-height: 1.4;
			float: left;
			text-align: left;
			width: 200px;
		}

		#industry-intro .intro-container .box .item img {
			width: 100%;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/IndustryIntro.vue